Toner = 
  start : () -> 
    Tone.context.resume()
    Tone.Transport.start()
  stop : () ->
    Tone.Transport.stop()
    Tone.context.suspend()

  win_level : (last) ->
    @env2.disconnect @fm.oscillator.frequency
    @env.connect(@fm.oscillator.frequency);
    @env.triggerAttackRelease("1s")
    if not last
      @fm.triggerAttackRelease("A3", "2s");
      window.setTimeout(@swap_env.bind(@), 1000)
    else
      @fm.triggerAttackRelease("A3", "1s");
  
  up : true

  swap_env : () ->
    @env.disconnect @fm.oscillator.frequency
    @env2.connect @fm.oscillator.frequency
    @env2.triggerAttackRelease("1s")

  miss_level : () ->
    @am.triggerAttackRelease("Gb2", "1s")
    @env3.triggerAttackRelease("1s")
  init : () ->
    @fm = new Tone.FMSynth(
      envelope : 
        attack : 0.1
        release : 2.0
    )
    @fm.harmonicity.value = 2.4
    @env = new Tone.FrequencyEnvelope({
      attack: 1.0,
      decay : 0
      sustain : 0
      baseFrequency: "G3",
      octaves: 4
      release : 0.5
    });
    @env2 = new Tone.FrequencyEnvelope({
      attack: 1.0,
      decay : 0
      sustain : 0
      baseFrequency: "C4",
      octaves: 1
      release : 0.5
    });

    @env3 = new Tone.FrequencyEnvelope({
      attack: 0.0,
      decay : 1.0
      sustain : 0
      baseFrequency: "C1",
      octaves: 2
      release : 0.0
    });

    filter = new Tone.AutoFilter(baseFrequency : 100, frequency : "64n").toDestination().start()
    @fm.connect filter
    hpf = new Tone.Filter(frequency : 280, type: "highpass").toDestination()

    @crush = new Tone.BitCrusher(7).connect hpf
    @am = new Tone.AMSynth(
      envelope : 
        attack : 0.5
        decay : 0.02
        sustain : 0.0
        release : 0.6
    ).connect @crush

    @env3.connect @am.frequency